import { render, staticRenderFns } from "./quality_work_detail.vue?vue&type=template&id=77b406a8&scoped=true"
import script from "./quality_work_detail.vue?vue&type=script&lang=js"
export * from "./quality_work_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b406a8",
  null
  
)

export default component.exports